module.exports = __webpack_public_path__ + "d13d54bd47690da1923adff81da06752.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/screech_owl_hoot.png
// module id = 3230
// module chunks = 0